//
// SortLevel.js
// BIRD
//
// Generated by Robots v0.
// Copyright (c) SAS Institute Inc. All rights reserved.
//
// DO NOT EDIT THIS FILE. IT IS GENERATED BY ROBOTS.
//
// Disable camelcase rule for generated code.
/* eslint-disable camelcase */
import { createModule } from "@sas-dvr/ltjs-commons/moduleBuilder";
import EventDispatcher from "@sas-dvr/ltjs-commons/events/EventDispatcher";
import "../../../lib";
import "../../BIRDModel";
import "@sas-dvr/ltjs-commons/models/data/sorting/SortDirection";
import "@sas-dvr/ltjs-commons/models/data/sorting/SortPreprocessing";

var SortLevel = createModule("BIRD::SortLevel", ["commons::PropertyOwner","commons::BaseModel","BIRD::BIRDModel"], EventDispatcher, [
    ,
    {
        sortDirection: 4,
        sortOn: 4,
        uniqueLevelName: 7,
    },
    ,
    ,
    ,
    {
        _create: [4],
    },
    ,
]);
export default SortLevel;
